// src/components/FormActividad.jsx
// Mejorado: Subtareas + Múltiples responsables

import React, { useState } from 'react';
import { Save, X, Plus, Trash2 } from 'lucide-react';

const FormActividad = ({ 
  onGuardar, 
  onCancelar, 
  actividadEditar, 
  meses, 
  etiquetasDisponibles,
  esRecurrente 
}) => {
  const [formData, setFormData] = useState(actividadEditar || {
    nombre: '',
    proposito: '',
    responsables: [], // ✅ CAMBIADO: Array de responsables
    fechaInicio: '',
    fechaCierre: '',
    estado: 'programada',
    etiquetas: [],
    subtareas: [], // ✅ Array de subtareas
    comentarios: [],
  });

  const [frecuencia, setFrecuencia] = useState('ninguna');
  const [nuevoResponsable, setNuevoResponsable] = useState(''); // ✅ Para agregar responsables
  const [nuevaSubtarea, setNuevaSubtarea] = useState(''); // ✅ Para agregar subtareas

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ✅ NUEVO: Agregar responsable
  const agregarResponsable = () => {
    if (nuevoResponsable.trim() && !formData.responsables.includes(nuevoResponsable)) {
      setFormData({
        ...formData,
        responsables: [...formData.responsables, nuevoResponsable.trim()]
      });
      setNuevoResponsable('');
    }
  };

  // ✅ NUEVO: Eliminar responsable
  const eliminarResponsable = (index) => {
    setFormData({
      ...formData,
      responsables: formData.responsables.filter((_, i) => i !== index)
    });
  };

  // ✅ NUEVO: Agregar subtarea
  const agregarSubtarea = () => {
    if (nuevaSubtarea.trim()) {
      setFormData({
        ...formData,
        subtareas: [...formData.subtareas, {
          id: Date.now(),
          texto: nuevaSubtarea.trim(),
          completada: false
        }]
      });
      setNuevaSubtarea('');
    }
  };

  // ✅ NUEVO: Eliminar subtarea
  const eliminarSubtarea = (index) => {
    setFormData({
      ...formData,
      subtareas: formData.subtareas.filter((_, i) => i !== index)
    });
  };

  const handleEtiquetaChange = (etiqueta) => {
    setFormData({
      ...formData,
      etiquetas: formData.etiquetas.includes(etiqueta)
        ? formData.etiquetas.filter(e => e !== etiqueta)
        : [...formData.etiquetas, etiqueta]
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.nombre || formData.responsables.length === 0 || !formData.fechaInicio || !formData.fechaCierre) {
      alert('Por favor completa: Nombre, al menos un responsable, y fechas');
      return;
    }

    // Convertir array de responsables a string para compatibilidad
    const dataGuardar = {
      ...formData,
      responsable: formData.responsables.join(', ') // Para compatibilidad con código existente
    };

    if (!actividadEditar) {
      onGuardar(dataGuardar, frecuencia);
    } else {
      onGuardar(dataGuardar);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Nombre */}
      <div>
        <label className="block text-gray-700 font-semibold mb-2">
          📝 Nombre de la Actividad *
        </label>
        <input
          type="text"
          name="nombre"
          value={formData.nombre}
          onChange={handleChange}
          placeholder="Ej: Reunión de padres"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        />
      </div>

      {/* Propósito */}
      <div>
        <label className="block text-gray-700 font-semibold mb-2">
          🎯 Propósito *
        </label>
        <textarea
          name="proposito"
          value={formData.proposito}
          onChange={handleChange}
          placeholder="Describe el propósito de esta actividad"
          rows="3"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          required
        />
      </div>

      {/* Responsables - MEJORADO */}
      <div>
        <label className="block text-gray-700 font-semibold mb-2">
          👥 Responsables * (Múltiples)
        </label>
        <div className="flex gap-2 mb-3">
          <input
            type="text"
            value={nuevoResponsable}
            onChange={(e) => setNuevoResponsable(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && agregarResponsable()}
            placeholder="Ej: Juan García"
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="button"
            onClick={agregarResponsable}
            className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
          >
            <Plus size={18} />
          </button>
        </div>
        
        {/* Lista de responsables */}
        <div className="space-y-2">
          {formData.responsables.map((responsable, index) => (
            <div key={index} className="flex items-center justify-between bg-gray-100 p-2 rounded">
              <span className="text-gray-700">{responsable}</span>
              <button
                type="button"
                onClick={() => eliminarResponsable(index)}
                className="text-red-600 hover:text-red-800"
              >
                <Trash2 size={16} />
              </button>
            </div>
          ))}
        </div>
        {formData.responsables.length === 0 && (
          <p className="text-sm text-red-500 mt-2">Debes agregar al menos un responsable</p>
        )}
      </div>

      {/* Fechas */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-gray-700 font-semibold mb-2">
            📅 Fecha de Inicio *
          </label>
          <input
            type="date"
            name="fechaInicio"
            value={formData.fechaInicio}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
        <div>
          <label className="block text-gray-700 font-semibold mb-2">
            📅 Fecha de Cierre *
          </label>
          <input
            type="date"
            name="fechaCierre"
            value={formData.fechaCierre}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
        </div>
      </div>

      {/* Estado */}
      <div>
        <label className="block text-gray-700 font-semibold mb-2">
          📊 Estado *
        </label>
        <select
          name="estado"
          value={formData.estado}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="programada">⏳ Programada</option>
          <option value="sin iniciar">❌ Sin Iniciar</option>
          <option value="en proceso">🔄 En Proceso</option>
          <option value="finalizada">✅ Finalizada</option>
          <option value="cancelada">⛔ Cancelada</option>
        </select>
      </div>

      {/* Recurrencia */}
      {!actividadEditar && (
        <div>
          <label className="block text-gray-700 font-semibold mb-2">
            🔁 Recurrencia (opcional)
          </label>
          <select
            value={frecuencia}
            onChange={(e) => setFrecuencia(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="ninguna">Sin repetición</option>
            <option value="diaria">Diaria (30 veces)</option>
            <option value="semanal">Semanal (12 veces)</option>
            <option value="quincenal">Quincenal (6 veces)</option>
            <option value="mensual">Mensual (12 veces)</option>
          </select>
        </div>
      )}

      {/* Subtareas - NUEVO */}
      <div>
        <label className="block text-gray-700 font-semibold mb-2">
          ✓ Tareas Específicas (opcional)
        </label>
        <div className="flex gap-2 mb-3">
          <input
            type="text"
            value={nuevaSubtarea}
            onChange={(e) => setNuevaSubtarea(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && agregarSubtarea()}
            placeholder="Ej: Preparar materiales"
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="button"
            onClick={agregarSubtarea}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            <Plus size={18} />
          </button>
        </div>
        
        {/* Lista de subtareas */}
        <div className="space-y-2">
          {formData.subtareas.map((subtarea, index) => (
            <div key={index} className="flex items-center justify-between bg-blue-50 p-2 rounded border border-blue-200">
              <span className="text-gray-700">✓ {subtarea.texto}</span>
              <button
                type="button"
                onClick={() => eliminarSubtarea(index)}
                className="text-red-600 hover:text-red-800"
              >
                <Trash2 size={16} />
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Categorías */}
      <div>
        <label className="block text-gray-700 font-semibold mb-2">
          🏷️ Categorías
        </label>
        <div className="space-y-2">
          {etiquetasDisponibles.map((etiqueta) => (
            <label key={etiqueta} className="flex items-center">
              <input
                type="checkbox"
                checked={formData.etiquetas?.includes(etiqueta) || false}
                onChange={() => handleEtiquetaChange(etiqueta)}
                className="mr-2 w-4 h-4 rounded"
              />
              <span className="text-gray-700">{etiqueta}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Botones */}
      <div className="flex gap-4 pt-6">
        <button
          type="submit"
          className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-semibold"
        >
          <Save size={20} />
          {actividadEditar ? 'Actualizar' : 'Guardar'}
        </button>
        <button
          type="button"
          onClick={onCancelar}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-gray-400 text-white rounded-lg hover:bg-gray-500 transition font-semibold"
        >
          <X size={20} />
          Cancelar
        </button>
      </div>
    </form>
  );
};

export default FormActividad;
